import { FieldValues, Control, Path } from 'react-hook-form';
import { Matcher } from 'react-day-picker';
import * as React from 'react';

import { FormControl, FormMessage, FormField, FormItem } from '../form';
import { DatePicker } from '../date-picker/date-picker';
import { cn } from '../../utils';

interface FormDatePickerProps<T extends FieldValues = FieldValues> {
  componentProps?: Partial<React.ComponentProps<typeof DatePicker>>;
  disabled?: Matcher[] | boolean | Matcher;
  size?: 'medium' | 'small' | 'large';
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  placeholder?: string;
  className?: string;
  required?: boolean;
  name: Path<T>;
}

export function FormDatePicker<T extends FieldValues>({
  required = false,
  hideErrorMessage,
  componentProps,
  formControl,
  placeholder,
  className,
  disabled,
  size,
  name,
}: FormDatePickerProps<T>) {
  return (
    <FormField
      render={({ field, formState }) => {
        const hasError = !!formState.errors[field.name];

        return (
          <FormItem className={cn('space-y-3', className)}>
            <FormControl>
              <DatePicker
                {...componentProps}
                {...field}
                onSelect={field.onChange}
                placeholder={placeholder}
                selected={field.value}
                disabled={disabled}
                required={required}
                hasError={hasError}
                inputSize={size}
                id={field.name}
              />
            </FormControl>
            {!hideErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
      control={formControl}
      name={name}
    />
  );
}
